@if (!isCheckbox) {
  <div>
    <label [innerHTML]="inputField.label"></label>
    @if (requiredField) {
      <scitis-required-field-indicator></scitis-required-field-indicator>
    }
  </div>
}

@if (isInput && !isCheckbox && !isDate) {
  <div class="form-group">
    <input (change)="setInputFieldValue()" [(ngModel)]="inputField.value" [ngClass]="getInputClass()"
      [placeholder]="inputField.placeholder"
      [type]="inputType" class="form-control">
    </div>
  }

  @if (isInput && !isCheckbox && isDate) {
    <scitis-date-time-picker (focusOut)="onFocusOutStartTime($event)"
      [showLabel]="false"
      [setChangeValue]="true"
      [showRequiredFieldIndicator]="false"
      [showRequiredMessage]="false"
      [showSeconds]="true"
      [startDate]="startDate"
      [startTime]="startTime"
      [textLabel]="inputField.label">
    </scitis-date-time-picker>
  }

  @if (isInput && isCheckbox) {
    <div class="form-group">
      <label [innerHTML]="inputField.label" for="checkbox"></label>
      @if (requiredField) {
        <scitis-required-field-indicator></scitis-required-field-indicator>
      }
      <input (change)="setCheckboxValue()" [(ngModel)]="isChecked" [ngClass]="getInputClass()"
        [ngStyle]="setCheckboxRequiredStyle()"
        [placeholder]="inputField.placeholder" class="form-check-input" id="checkbox"
        type="checkbox">
      </div>
    }

    @if (isDropdown ) {
      <div class="form-group">
        <ng-select (change)="setDropdownValue()" [(ngModel)]="dropDownModel"
          [closeOnSelect]="!isMultipleDropdown" [items]="inputField.options"
          [multiple]="isMultipleDropdown" [ngClass]="getInputClass()"
          [placeholder]="inputField.placeholder">
        </ng-select>
      </div>
    }

    @if (isList) {
      <div class="form-group">
        <div class="input-group">
          <input [(ngModel)]="listEntry" [ngClass]="getInputClass()" [placeholder]="addListItemText" [type]="inputType"
            class="form-control"/>
            <div class="input-group-append">
              <button (click)="onAddListItem()" class="btn btn-outline-secondary"
                type="button">
                <span translate>Add</span>
              </button>
            </div>
          </div>
          <ul class="list-group">
            @for (value of inputField.valueList; track value) {
              <li class="list-group-item">
                <span [innerHTML]="value"></span>
                <button (click)="onDeleteListItem(value)" class="btn btn-outline-danger btn-sm float-right" type="button">
                  &times;
                </button>
              </li>
            }
          </ul>
        </div>
      }
